import React, { useEffect, useState } from 'react';
import { UserAuth } from '../../context/AuthContext';

import { useNavigate } from 'react-router-dom';
import "./style/dashboard.css"
import axios from 'axios';
import { data } from 'autoprefixer';
const Dashboard = () => {
  const { logOut, user } = UserAuth();
  const [storeexists,SetStoreExists]=useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.log(error);
    }
  };
  const checkifExists=async()=>{
    if(user.email){
      axios.post('https://dfghtyudgh.onrender.com/store/checkexists',({"email":user.email})).then((data)=>{
        if(data.data.success===true){
          console.log(data.data)
          SetStoreExists(true)
        }
      })
    }
  }
  useEffect(()=>{
    checkifExists()

    
  },[checkifExists]);
  return (
    <div className='dash-container'>
      <h1 className='heading'>Bussiness Dashboard</h1>
      
     { !storeexists ?  <><p>Welcome, {user?.displayName}</p>
        <p>You don't seem to have a shop</p>
        <div className='dash-buttons'><button className='create-shop' onClick={() => navigate('/dashboard/FormDash')}>
          Create Shop
        </button>
        <button onClick={handleSignOut} className='border py-2 px-5 mt-10'>
        Logout
      </button></div></> : <><button onClick={()=> navigate('/dashboard/openshop')}>Go to Shop</button></>}
        
      
      
      
    </div>
  );
};

export default Dashboard;
